/**
 * 자동 이벤트 수집 — 페이지뷰, 스크롤, 클릭 추적기 통합 관리
 */

import type { LambAnalytics } from '../core/sdk';
import type { SdkConfig } from '../core/config';
import { PageViewTracker } from './page-view';
import { ScrollTracker } from './scroll';
import { ClickTracker } from './click';
import { EngagementTracker } from './engagement';

export class AutoTrackManager {
  private pageViewTracker: PageViewTracker | null = null;
  private scrollTracker: ScrollTracker | null = null;
  private clickTracker: ClickTracker | null = null;
  private engagementTracker: EngagementTracker | null = null;

  init(sdk: LambAnalytics, config: SdkConfig): void {
    const autoTrack = config.autoTrack;

    if (autoTrack.pageView) {
      this.pageViewTracker = new PageViewTracker(sdk);
      this.pageViewTracker.start();
    }

    if (autoTrack.scroll) {
      this.scrollTracker = new ScrollTracker(sdk);
      this.scrollTracker.start();
    }

    if (autoTrack.outboundClick || autoTrack.fileDownload || autoTrack.siteSearch) {
      this.clickTracker = new ClickTracker(sdk, {
        outboundClick: autoTrack.outboundClick,
        fileDownload: autoTrack.fileDownload,
        siteSearch: autoTrack.siteSearch,
      });
      this.clickTracker.start();
    }

    // engagement: false 면 비활성, 객체면 주기/유휴 컷오프 지정, 그 외(true/생략)는 기본값.
    const engagement = autoTrack.engagement;
    if (engagement !== false) {
      const options = typeof engagement === 'object' ? engagement : {};
      this.engagementTracker = new EngagementTracker(sdk, options);
      this.engagementTracker.start();
    }
  }

  destroy(): void {
    if (this.pageViewTracker) {
      this.pageViewTracker.stop();
      this.pageViewTracker = null;
    }
    if (this.scrollTracker) {
      this.scrollTracker.stop();
      this.scrollTracker = null;
    }
    if (this.clickTracker) {
      this.clickTracker.stop();
      this.clickTracker = null;
    }
    if (this.engagementTracker) {
      this.engagementTracker.stop();
      this.engagementTracker = null;
    }
  }
}
